import * as Yup from 'yup';

export const recoverSchema = Yup.object().shape({
    email: Yup.string().email('recover.validEmail').required('recover.email'),
});
